import { HttpRequest } from "../utils";

const httpRequest = new HttpRequest();

export const list = async (data: any) => await httpRequest.get("/api/settlement", data);

export const respond = async (id: string) => await httpRequest.put(`/api/settlement/${id}/respond`); //Тооцоо үлдэгдэл зөвшөөрөх
